var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16a1 1 0 110 2 1 1 0 010-2zM16.25 16.25a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h4.5zM8 10a1 1 0 110 2 1 1 0 010-2zM16.25 10.25a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h4.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.102 2.005A1 1 0 0117 3v1h2l.102.005A1 1 0 0120 5v16l-.005.102a1 1 0 01-.893.893L19 22H5l-.103-.005a1 1 0 01-.892-.893L4 21V5a1 1 0 01.897-.995L5 4h2V3a1 1 0 01.897-.995L8 2h8l.102.005zM5.5 20.5h13v-15H17V6l-.005.103a1 1 0 01-.893.892L16 7H8l-.103-.005a1 1 0 01-.892-.892L7 6v-.5H5.5v15zm3-15h7v-2h-7v2z",
    fill: "currentColor"
  })));
}
SvgDocument.displayName = 'Document';
export default SvgDocument;